export default {
	messages: {
		de: {
			headlines: {
				commonData: 'Allgemein',
				worker: 'Mitarbeiter',
			},
			workerId: 'ID',
			workerName: 'Name',
			worker: 'Mitarbeiter',
			address: 'Adresse',
			birthday: 'Geburtstag',
			insuranceNumber: 'SV-Nummer',
		},
		en: {
			headlines: {
				commonData: 'Common Data',
				worker: 'Worker',
			},
			workerName: 'Name',
			address: 'Address',
			worker: 'Worker',
		},
	},
};
